import { register } from '@client/new/api/user.api';
import { useUser } from '@client/new/hooks/use-user';
import { emitGAEvent } from '@client/new/services/ga4';
import { useSignUpStore } from '@client/new/stores/sign-up.store';
import { PATHS, navigate } from '@client/routes';
import { trackLogin } from '@services/mixpanel';

export function useSignUp() {
  const { login } = useUser();
  const s = useSignUpStore();

  const register = createRegister(login);

  return {
    login,
    register: (token: string) =>
      register({
        email: s.email,
        firstName: s.firstName,
        lastName: s.lastName,
        salesModel: s.salesModel,
        profileInstagram: s.profileInstagram,
        token,
      }),
  };
}

function createRegister(login: (user: any) => void) {
  return (data: {
    token: string;
    email: string;
    firstName: string;
    lastName: string;
    salesModel: string;
    profileInstagram: string;
  }) =>
    register(data)
      .then((user) => {
        trackLogin({
          uid: user.id + '',
          'First Name': user.firstName,
          'Last Name': user.lastName,
          Email: user.email,
        });
        emitGAEvent({
          type: 'Registration Completed',
          payload: { influencer_id: user.influencerId },
        });

        login(user);
      })
      .then(() => {
        navigate(PATHS.HOME);
      });
}
